export const page = {
    name: 'Page',
    description: '',
    displayField: 'title',
    fields: {
        route: {
            name: 'Route',
            type: 'Link',
            linkType: 'Entry',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['route'] }]
        },
        variant: {
            name: 'Variant',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ unique: true }]
        },
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        metaDescription: {
            name: 'Meta Description',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        metaImage: {
            name: 'Meta Image',
            type: 'Link',
            linkType: 'Asset',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkMimetypeGroup: ['image'] }]
        },
        canonical: {
            name: 'Canonical',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        sections: {
            name: 'Sections',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [
                    {
                        linkContentType: [
                            'uiAddToSlackSection',
                            'uiFooter',
                            'uiGuide',
                            'uiHeader',
                            'uiListCarousel',
                            'uiNavImages',
                            'uiPlaceholder',
                            'uiRotatingItems',
                            'uiSection',
                            'uiStoryline',
                            'uiTechDemo',
                            'uiTemplateGallery'
                        ]
                    }
                ],
                linkType: 'Entry'
            }
        },
        background: {
            name: 'Background',
            type: 'Object',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        cookieBanner: {
            name: 'Cookie Banner',
            type: 'Link',
            linkType: 'Entry',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['uiCookieBanner'] }]
        },
        noIndexTag: {
            name: 'Hide page from search engines (noindex)',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        noFollowTag: {
            name: 'Exclude from search rankings (nofollow)',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=page.js.map